import React, { useEffect, useRef, useState } from 'react';
import Input from '../../ui/input';
import { validateCamera } from '../../../model/CameraModel'; // Import the camera model and validation function
import Select from '../../ui/select';
import { getSites } from '../../../redux/api/siteAPI';
import { getZones } from '../../../redux/api/zoneAPI';
import { cameraAdd } from '../../../redux/api/cameraAPI';
import Textarea from '../../ui/textarea';
import Button from '../../ui/button';
import axios from "axios";
import Cookies from 'js-cookie';
import { API } from '../../../redux/api/utils';
import './updstyle.css';

import { useTranslation } from 'react-i18next';

const AddCameraVidModal = ({ isOpen, onClose, setIsUploading  }) => {
    const {t} = useTranslation('common');
    const [formData, setFormData] = useState({
        Name: '',
        url: '',
        Manufacturer: '',
        productID: "",
        Model: "",
        IP_Address: '',
        Port_Number: '',
        Username: '',
        Password: '',
        Zone: '',
        Site: '',
    });

    const [formErrors, setFormErrors] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [zonesList, setZonesList] = useState([]);
    const [sitesList, setSitesList] = useState([]);
    const [errorAdd, setErrorAdd] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (formErrors[name]) {
            setFormErrors(prevState => ({
                ...prevState,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        console.log(formData);
        e.preventDefault();
        try {
            const result = await cameraAdd(formData);
            if (result.data) {
                closeModal(true);
            } else {
                setErrorAdd(result.error?.msg || result.error || "Error adding camera");
            }
        } catch (error) {
            console.error("Error adding camera:", error);
            setErrorAdd(error?.msg || error.message || "Error adding camera");
        }
    };

    const closeModal = (refresh=false) => {
        if (loading) return;
        setZone(null)
        setSite(null)
        setFormData({});
        setFormErrors({});
        setErrorAdd(null);
        onClose(refresh);
    };



    const [site, setSite] = useState(null)
    const [zone, setZone] = useState(null)
    useEffect(() => {
        const fetchData = async () => {
            // setLoading(true);
            try {
                const [sitesRes, zonesRes] = await Promise.all([
                    getSites(),
                    getZones()
                ]);
                setSitesList(sitesRes.data.sites)
                setZonesList(site ? zonesRes.data.zones.filter(zone => zone.Site_ID === site.Site_ID) : zonesRes.data.zones)

            } catch (err) {
                setError(err);
                //static

            } finally {
                // setLoading(false);
            }
        };
        fetchData();
    }, [zone, site]);

    const handleSelectZone = (option) => {
        if (option) {
            const foundZone = zonesList.find(zone => zone.Zone_ID === option.value);
            setZone(foundZone)
            setSite(foundZone?.site || null)
            setFormData(prevState => ({ ...prevState, Zone: option.value, site: foundZone?.site || null }))

        }
        else {
            setFormData(prevState => ({ ...prevState, Site: null, zone: null }))
            setZone(null)
            setSite(null)
        }
    }
    const handleSelectSite = (option) => {
        if (option) {
            setFormData(prevState => ({ ...prevState, Site: option.value }))
            const foundSite = sitesList.find(site => site.Site_ID === option.value);
            setZone(null)
            setSite(foundSite)
        }
        else {
            setFormData(prevState => ({ ...prevState, Site: null, zone: null }))
            setZone(null)
            setSite(null)
        }

    }

    const [file, setFile] = useState(null);
    const [success, setSuccess] = useState(null);
    const [progress, setProgress] = useState(0); // Track upload progress

    const handleFileChange = (event) => {
        const selectedFile = event.target.files?.[0];
        console.log("Selected file:", selectedFile); // Debugging line
    
        if (!selectedFile) {
            setError("Please select a file first.");
            setFile(null);
            return;
        }
    
        // Validate file type
        if (selectedFile.type !== "video/mp4") {
            setError("Only MP4 files are allowed.");
            setFile(null);
            return;
        }
    
        // Validate file size (500MB max)
        const maxSize = 500 * 1024 * 1024; // 500MB in bytes
        if (selectedFile.size > maxSize) {
            setError("File size must be less than 500MB.");
            setFile(null);
            return;
        }
    
        // If validation passed, set file state and reset error message
        setFile(selectedFile);
        setError(""); // Clear any previous errors
        console.log("File is valid, preparing upload..."); // Debugging line
    
        // Trigger the upload process after file is set
        handleUpload(event); // No need to pass the file directly here
    };

    const handleUpload = async (event) => {
        // Check if file exists
        const selectedFile = event.target.files?.[0];
        if (!selectedFile) {
            console.log("No file to upload, skipping."); // Debugging line
            setError("Please select a file first."); // Set error if file is not passed to upload
            return;
        }
    
        // Reset the state before the upload starts
        setIsUploading(true);
        setLoading(true);
        setError(null);
        setSuccess(null);
        setProgress(0);
        console.log("Uploading file:", selectedFile.name); // Debugging line
    
        const formData = new FormData();
        formData.append("file", selectedFile);
    
        try {
            const response = await API.post("/upload-minio/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setProgress(percent);
                }
            });
    
            setFormData(prevState => ({ ...prevState, url: response.data.url }));
            setSuccess("Upload successful!");
            console.log("Upload successful:", response.data); // Debugging line
        } catch (error) {
            setError("Upload failed. Please try again.");
            console.error("Upload failed:", error);
        } finally {
            setLoading(false);
            setTimeout(() => setIsUploading(false), 1000); // Delay closing modal after update
        }
    };





    if (!loading)

        return (
            //     </div>
            // </div>
            <form onSubmit={handleSubmit}>
                {/* <AppTour /> */}
                <div className="overflow-y-auto grid  gap-7 max-lg:grid-cols-1 grid-cols-2 w-auto m-2 bg-white max-md: p-8 rounded-3xl shadow-lg">
                    <p className="flex justify-center col-span-full text-xl text-[#4C4C66] font-bold mb-4">{t('upload_camera_video')}</p>
                    <div className="col-span-full step12">
                        <div className="upload-container">
                            <input
                                type="file"
                                accept="video/mp4"
                                onChange={handleFileChange}
                            />
                            {error && <p className="error-text">{error}</p>}
                            {success && <p className="success-text">{success}</p>}

                            <div>
                                <div className="progress-bar">
                                    <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                                </div>
                                <p className="flex justify-center">{progress}{t('')}</p>
                                <p className="text-gray-500">
                                    Make sure the size is less than <strong>500MB</strong> and the file type is <strong>MP4</strong>.
                                </p>
                            </div>
                        </div>
                    </div>



                            <div className=" step13 col-span-full w-1/2 pr-10 max-lg:pr-5 max-lg:w-full max-lg:col-span-1">
                                <Input
                                    required
                                    label={t('video_name')}
                                    name="Name"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    placeholder={t('enter_video_name')}
                                    error={formErrors.Name}
                                />
                            </div>
                            <div className='step13'>


                                {site?.Name ? (
                                    <Select
                                        isClearable={true}
                                        required
                                        options={sitesList.map(site => ({
                                            label: site.Name,
                                            value: site.Site_ID
                                        }))}
                                        label={t('select_site')}
                                        value={{
                                            value: site?.Site_ID,
                                            label: site?.Name
                                        }}
                                        className='min-w-[300px] '
                                        onChange={(option) => handleSelectSite(option)}
                                        placeholder={t('select_site')}
                                        error={formErrors.Site}
                                    />
                                ) : (
                                    <Select
                                        isClearable={true}
                                        required
                                        options={sitesList.map(site => ({
                                            label: site.Name,
                                            value: site.Site_ID
                                        }))}
                                        label={t('select_site')}
                                        className='min-w-[300px] '
                                        onChange={(option) => handleSelectSite(option)}
                                        placeholder={t('select_site')}
                                        error={formErrors.Site}
                                    />
                                )}
                            </div>
                            <div className='step15'>


                                {
                                    zone?.Zone_name ? (<Select
                                        isClearable={true}
                                        required
                                        options={zonesList.map(zone => ({
                                            label: zone.Zone_name,
                                            value: zone.Zone_ID
                                        }))}
                                        label={t('select_zone')}
                                        value={{
                                            value: zone?.Zone_ID,
                                            label: zone?.Zone_name
                                        }}
                                        onChange={(option) => handleSelectZone(option)}
                                        placeholder={t('select_zone')}
                                        error={formErrors.Zone}
                                    />) : (<Select
                                        isClearable={true}
                                        required
                                        options={zonesList.map(zone => ({
                                            label: zone.Zone_name,
                                            value: zone.Zone_ID
                                        }))}
                                        label={t('select_zone')}
                                        onChange={(option) => handleSelectZone(option)}
                                        placeholder={t('select_zone')}
                                        error={formErrors.Zone}
                                    />)
                                }
                            </div>

                    {errorAdd && (
                        <div className="col-span-full flex justify-center space-x-5">
                            <span className="my-4 ml-2 text-xs text-[#FF0000]">
                                {t('error')} {errorAdd}
                            </span>
                        </div>
                    )}
                    <div className='col-span-full flex justify-center mt-10 space-x-5'>
                        <Button type="reset" onClick={closeModal} size="large" color="cancel" >{t('cancel')}</Button>
                        <Button type="submit" size="large"  >{t('add')}</Button>
                    </div>
                </div>
            </form>
        );
};

export default AddCameraVidModal;
